module.exports = __webpack_public_path__ + "img/3_4.9f904259.png";